import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import "./index.css";

import Home from "./pages/Home/Home";
import Attributions from "./pages/Attributions/Attributions";
import Collaborations from "./pages/Collaborations/Collaborations";
import Communication from "./pages/Communication/Communication";
import Contribution from "./pages/Contribution/Contribution";
import Description from "./pages/Description/Description";
import Engineering from "./pages/Engineering/Engineering";
import HumanPractices from "./pages/HumanPractices/HumanPractices";
import Implementation from "./pages/Implementation/Implementation";
import Model from "./pages/Model/Model";
import Parts from "./pages/Parts/Parts";
import ProofOfConcept from "./pages/ProofOfConcept/ProofOfConcept";
// import Team from "./pages/Team/Team";
import Members from "./pages/Team/Team";

import NavBar from "./components/Navbar/Navbar";
import Toolbar from "./components/Toolbar/Toolbar";
import Footer from "./components/Footer/Footer";

function App() {
  let [fontSize, setFontSize] = useState(0);

  const handleFontSize = (isIncreasing) => {
    if (isIncreasing) {
      if (fontSize < 8) {
        setFontSize(fontSize + 2);
        console.log("increasing");
      }
    } else {
      if (fontSize > -2) {
        setFontSize(fontSize - 2);
        console.log("decreasing");
      }
    }
  };

  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
  );

  const darkModeToggle = () => {
    localStorage.setItem("theme", theme === "light" ? "dark" : "light");
    theme === "light" ? setTheme("dark") : setTheme("light");
    console.log(theme);
  };

  const handleKeyPress = useCallback((event) => {
    if (event.altKey && event.key === "d") {
      console.log(`Key pressed: ${event.key}`);
      setTheme("dark");
    } else if (event.altKey && event.key === "l") {
      console.log(`Key pressed: ${event.key}`);
      setTheme("light");
    } else if (event.altKey && event.key === "/") {
      document.location.href = ".";
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "p") {
      document.location.href = "/waterloo/description";
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "c") {
      document.location.href = "/waterloo/parts";
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "h") {
      document.location.href = "/waterloo/human-practices";
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "t") {
      document.location.href = "/waterloo/attributions";
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "b") {
      document.location.href = document.history.location.pathname;
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "i") {
      window.open("https://www.instagram.com/waterloo.igem/?hl=en", "_blank");
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "f") {
      window.open("https://www.facebook.com/WaterlooiGEM/", "_blank");
      console.log(`Key pressed: ${event.key}`);
    } else if (event.altKey && event.key === "g") {
      window.open("https://github.com/igem-waterloo/uwaterloo-igem-2022/tree/main", "_blank");
      console.log(`Key pressed: ${event.key}`);
    } else if (event.shiftKey === true && event.keyCode === 38) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      console.log(`Key pressed: ${event.key}`);
    } else if (event.shiftKey === true && event.keyCode === 40) {
      window.scrollTo(0, document.body.scrollHeight, { behavior: "smooth" });
      console.log(`Key pressed: ${event.key}`);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <div className="app-container" data-theme={theme}>
      <Toolbar
        handleFontSize={handleFontSize}
        darkModeToggle={darkModeToggle}
        theme={theme}
      />
      <div className="main">
        <NavBar />

        {/* Routes */}
        <BrowserRouter>
          <Routes>
            <Route
              exact
              path="/waterloo"
              element={<Home fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/attributions"
              element={<Attributions fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/collaborations"
              element={<Collaborations fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/communication"
              element={<Communication fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/contribution"
              element={<Contribution fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/description"
              element={<Description fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/engineering"
              element={<Engineering fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/human-practices"
              element={<HumanPractices fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/implementation"
              element={<Implementation fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/members"
              element={<Members fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/model"
              element={<Model fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/parts"
              element={<Parts fontSize={fontSize} />}
            />
            <Route
              exact
              path="/waterloo/proof-of-concept"
              element={<ProofOfConcept fontSize={fontSize} />}
            />
            {/* <Route
              exact
              path="/waterloo/team"
              element={<Team fontSize={fontSize} />}
            /> */}
          </Routes>
        </BrowserRouter>
      </div>

      <div className="lines1" style={{ position: "absolute", top: "-6vh" }}>
        <svg
          width="9vw"
          height="auto"
          viewBox="0 0 191 401"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M190 278.5H98V399.5H-58"
            stroke="var(--text-secondary)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M-18 1.5H33V248H189.5"
            stroke="var(--text-secondary)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <div
        className="lines2"
        style={{ position: "absolute", top: "13vh", right: "0vh" }}
      >
        <svg
          width="80vw"
          height="auto"
          viewBox="0 0 1288 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 24.9024V1H831.638V71H1473"
            stroke="var(--text-secondary)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <Footer className="footer" theme={theme} />
    </div>
  );
}

export default App;
